 
import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Contact from './Contact';
import Services from './Services';
import Skills from './Skills';
import { motion } from 'framer-motion';
import Portfolio from './Portfolio';
import "../components/Navbar/navbar.css";
import Footer from './Navbar/Footer';
import { Typewriter } from 'react-simple-typewriter';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  const [activeLink, setActiveLink] = useState('home');

  const homeRef = useRef(null);
  const servicesRef = useRef(null);
  const skillsRef = useRef(null);
  const portfolioRef = useRef(null);
  const contactRef = useRef(null);
  const footerRef = useRef(null);

  const handleScrollToSection = (ref) => {
    if (ref && ref.current) {
      let sectionTop = ref.current.offsetTop;
      if (ref === servicesRef) sectionTop += 100;
      else if (ref === skillsRef) sectionTop += 150;
      window.scrollTo({
        top: sectionTop,
        behavior: 'smooth',
      });
    }
  };

  const handleNavLinkClick = (linkName, ref) => {
    setActiveLink(linkName);
    handleScrollToSection(ref);
  };

  const handleScroll = () => {
    const scrollPosition = window.scrollY + 200;
    if (servicesRef.current && scrollPosition >= servicesRef.current.offsetTop) setActiveLink('services');
    if (skillsRef.current && scrollPosition >= skillsRef.current.offsetTop) setActiveLink('skills');
    if (portfolioRef.current && scrollPosition >= portfolioRef.current.offsetTop) setActiveLink('portfolio');
    if (contactRef.current && scrollPosition >= contactRef.current.offsetTop) setActiveLink('contact');
    if (footerRef.current && scrollPosition >= footerRef.current.offsetTop) setActiveLink('footer');
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="w-full lg:max-w-7xl   mx-auto min-h-screen bg-pink-200">
      <Helmet>
        <title>Musnud Billah Faysal Portfolio</title>
      </Helmet>
      <header className="w-full lg:max-w-7xl mx-auto bg-gray-300 text-red-600 fixed   flex justify-between items-center z-20 px-1 py-2">
        <a href="/">
          <section>
            <div className="flex items-center p-12">
              <div className="relative ml-12 flex items-center justify-center border-4 p-1 rounded-full border-red-500">
                <h2 className="font-bold text-red-500 font-mono text-sm">MBF</h2>
                <motion.div
                  className="absolute inset-0 text-container"
                  initial={{ rotate: 0 }}
                  animate={{ rotate: 360 }}
                  transition={{ repeat: Infinity, duration: 10, ease: "linear" }}
                >
                  {Array.from("musnudbillahfaysal").map((letter, index) => (
                    <span
                      key={index}
                      className="text-sm"
                      style={{
                        position: "absolute",
                        transform: `rotate(${index * (360 / 19)}deg) translate(0, -50px) rotate(-${index * (360 / 19)}deg)`,
                      }}
                    >
                      {letter}
                    </span>
                  ))}
                </motion.div>
              </div>
            </div>
          </section>
        </a>
        <nav className="hidden lg:block">
          <ul className="flex space-x-8">
            {['home', 'services', 'skills', 'portfolio', 'contact'].map((link) => (
              <li key={link}>
                <Link
                  to="#"
                  className={`${activeLink === link ? 'underline' : ''
                    } text-lg`}
                  onClick={() => handleNavLinkClick(link, {
                    home: homeRef,
                    services: servicesRef,
                    skills: skillsRef,
                    portfolio: portfolioRef,
                    contact: contactRef
                  }[link])}
                >
                  {link.toUpperCase()}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="button-container">
          <Link
            to="#"
            className="bg-[#d78109] button"
            onClick={() => handleNavLinkClick('contact', contactRef)}
          >
            Hire ME
          </Link>
        </div>
      </header>
      <main className="flex flex-col justify-between items-center lg:py-24  ">
        <div className="body lg:max-w-7xl mx-auto lg:py-24 z-10">
          <div className="intro-container overflow-hidden flex flex-col-reverse md:flex-row-reverse items-center md:items-start mb-2 lg:mb-32">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mx-auto ml-0 lg:ml-3">
              <div className="intro-content-text text-center md:text-left px-4 lg:px-12">
                <h3 className="text-black uppercase text-xl md:text-2xl tracking-wide font-semibold mb-3 md:mb-4 py-4 mt-52 lg:mt-2 lg:py-1">
                  👋, My name is <br></br> <br></br><span className='font-bold'>Musnud Billah Faysal</span>
                </h3>
                <h1 className="text-black font-semibold text-2xl md:text-4xl xl:text-5xl leading-tight mb-4 md:mb-6">
                  <span className="text-2xl md:text-6xl mb-12">I'm a</span>
                  <span className="block text-red-600 font-bold text-3xl md:text-3xl mt-12">
                    <Typewriter
                      words={['React Developer', 'Frontend Developer', 'Web Developer']}
                      loop={5000}
                      cursor
                      cursorStyle=".."
                      typeSpeed={100}
                      deleteSpeed={50}
                      delaySpeed={1000}
                    />
                  </span>
                </h1>
                <div className="button-container">
                  <p className='py-6 lg:py-12'>Based in Dhaka, Bangladesh.</p>
                  <a
                    href="https://drive.google.com/uc?export=download&id=1PjxAxQlhdx8xoAg8BY6TwZMEPktt9KYa"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#916211] button"
                    onClick={() => handleNavLinkClick('contact', contactRef)}
                  >
                    Download CV
                  </a>
                </div>
              </div>
              <div className="intro-content-img w-full md:w-3/4 px-4 md:px-0">
                <img
                  className="rounded-xl shadow-lg w-full h-auto object-cover overflow-hidden "
                  src="/images/faysal5.jpg"
                  alt="ima"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="service-container z-10  " ref={servicesRef}>
          <Services />
        </div>
        <div className="service-container z-10" ref={skillsRef}>
          <Skills />
        </div>
        <div className="service-container z-10" ref={portfolioRef}>
          <Portfolio />
        </div>
        <div className="service-container z-10" ref={contactRef}>
          <Contact />
        </div>
        
          
      </main>
      <Footer />
    </div>
  );
};

export default Home;

